@if (accaBoostNotification()?.type === notificationTypeEnum.Ladder) {
    <bs-acca-boost-notification
        class="quick-bet-acca-boost-notification acca-boost-notification--ladder"
        *bsAccaRerenderer="accaBoostNotification()?.token"
        [notification]="accaBoostNotification()"
        [icon]="'theme-info'"
        [usLadderEnabled]="false"
        [@.disabled]="true"
        @accaBoostNotificationAnimation
        (@accaBoostNotificationAnimation.done)="onAnimationDone($event, notificationTypeEnum.Ladder)">
        <bs-acca-boost-ladder [usLadderEnabled]="false" [notification]="accaBoostNotification()"></bs-acca-boost-ladder>
    </bs-acca-boost-notification>
}

@if (accaBoostNotification()?.type === notificationTypeEnum.MaxReward) {
    <bs-acca-boost-notification
        class="acca-boost-notification--ladder acca-boost-notification--max-reward quick-bet-acca-boost-notification"
        [usLadderEnabled]="false"
        @accaBoostNotificationAnimation>
        <bs-acca-boost-ladder [usLadderEnabled]="false" [notification]="accaBoostNotification()"></bs-acca-boost-ladder>
    </bs-acca-boost-notification>
}
